
import { Component, Vue } from 'vue-property-decorator';
import { StoreList } from '@/collections/stores';
import { StoreModel } from '@/models/store';
import { buildImpersonationUrl } from '@/utils/appLinks';

@Component({
  components: {
  },
})
export default class PassedTrialStores extends Vue {
  public isLoading: boolean = true;
  public stores: StoreList = new StoreList();

  public async created() {
    await this.fetchData();
  }

  public async fetchData() {
    this.isLoading = true;
    this.stores = new StoreList();
    await this.stores.getPassedTrialStores();
    this.isLoading = false;
  }

  public async loginAsMerchant(store: StoreModel) {
    const token: string = await store.generateLink();
    window.open(buildImpersonationUrl(token, store.name), '_blank');
  }

}
